module.exports = __webpack_public_path__ + "static/Alice_Descamps-c2682426869e947a106374dc4e54fead.png";